import * as React from 'react';
import { SeparatorW2, ConfigurationSection } from 'features/Dealers/DealerConfiguration/styles';
import DealerInfo from 'features/Dealers/Listings/Info';
import DealerLM from 'features/Dealers/Listings/Data';
import { shallowEqual, useSelector } from 'react-redux';
import { RootState } from 'store/types';
import Loader from 'components/Loader';
import { useDispatch } from 'react-redux';
import { getListingSyncErrors } from 'features/Dealers/Listings/state/actions';
import { updateSelectedDealer } from 'features/Dealers/DealerSelect/state/actions';

const Listing = (props: any) => {

    const {
        selectedListing,
        selectedDealer
    } = useSelector((rootState: RootState) => {
        return {
            selectedListing: rootState.dealers.listing.listings.selectedListingId,
            selectedDealer: rootState.dealers.dealer.selectedDealer,
        }
    }, shallowEqual);

    const dispatch = useDispatch();
    React.useEffect(() => {
        if (selectedListing) {
            dispatch(getListingSyncErrors(selectedListing))
        }
    }, [selectedListing])
   
    if (!selectedListing) {
        return (
            <Loader />
        )
    }

    return (
        <>
            <ConfigurationSection>
                <DealerInfo />
            </ConfigurationSection>
            <ConfigurationSection>
                <DealerLM />
            </ConfigurationSection>
        </>
    )

}

export default Listing;